import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWithdrawalFee } from 'services/WalletsService'
import { logError } from '@node-space/utils'

export const useWithdrawalFeeQuery = (walletId: number, amount: number, enabled = false) => {
  return useQuery(
    reactQueryKeys.withdrawalFee(walletId, amount),
    () => getWithdrawalFee(walletId, amount),
    {
      onError: error => logError('Error from useWithdrawalFeeQuery - getWithdrawalFee', error),
      enabled,
    }
  )
}
